import { Metric } from '@repo/types';
import c from 'classnames';
import { Typography } from 'components';
import useGetKitIdParam from 'hooks/useGetKitIdParam';
import useActionPlanData from 'services/actionPlan/actionPlanData';
import styles from './MetricsCategories.module.css';
import SubMetricRow from './SubMetricRow';

type MetricRowProps = {
  metric: Metric;
  idx: number;
  topPriorityRanks: Map<number, number>;
  hasAnyChart: boolean;
};

export default function MetricRow({
  metric,
  idx,
  topPriorityRanks,
  hasAnyChart,
}: MetricRowProps) {
  const kitId = useGetKitIdParam();
  const { data: allActions } = useActionPlanData({ kitId: kitId });

  return (
    <div className={styles.metricRow}>
      <div className={styles.textsContainer}>
        <Typography variant='eyebrow'>{metric.name}</Typography>
        {idx === 0 && (
          <div className={c(styles.columns, hasAnyChart && styles.hasChart)}>
            <Typography variant='caption' color='grey'>
              Result
            </Typography>
            {hasAnyChart && (
              <Typography
                variant='caption'
                color='grey'
                className='hide-on-mobile'
              >
                Progress
              </Typography>
            )}
          </div>
        )}
      </div>
      <div
        className={c(
          styles.submetricsContainer,
          metric.orderedSubmetrics.length === 1 && styles.singleSubmetric,
        )}
      >
        {metric.orderedSubmetrics.map((submetric, idx) => (
          <SubMetricRow
            key={`${submetric.id}-${idx}`}
            submetric={submetric}
            allActions={allActions ?? []}
            topPriorityRanks={topPriorityRanks}
            reserveChartSpace={hasAnyChart}
          />
        ))}
      </div>
    </div>
  );
}
